import { useOnline } from '../../hooks';
import { isForbidden, isShowChallenge, useAppSelector } from '../../store';
import { ConditionalRender } from '../../foundation';
import React from 'react';
import { ChallengeIframe } from './ChallengeIframe';

export const Challenge: React.FC = () => {
    const statusShowChallenge = useAppSelector(isShowChallenge);
    const statusForbidden = useAppSelector(isForbidden);
    const isOnline = useOnline();

    return (
        <ConditionalRender condition={isOnline && (statusForbidden || statusShowChallenge)}>
            <ChallengeIframe />
        </ConditionalRender>
    );
};
